import { createBaseComponents } from '../../base/tokens/components'

// should match base values until we have a need for different values
export const journeyUiComponents = { ...createBaseComponents() }
